/**
 * Vocabulary Page - Main learning interface
 * Allows users to choose between grade-based learning or category-based learning
 */

import { useState } from 'react';
import { UserProgress } from '../services/storage';
import VocabularyGradePage from '../components/vocabulary/VocabularyGradePage';

interface VocabularyPageProps {
  user: UserProgress;
}

export default function VocabularyPage({ user }: VocabularyPageProps) {
  const [viewMode, setViewMode] = useState<'grade' | 'category'>('grade');

  return (
    <div>
      {/* View mode toggle */}
      <div className="mb-6 flex gap-2 justify-center">
        <button
          onClick={() => setViewMode('grade')}
          className={`px-6 py-3 rounded-2xl font-medium transition-all ${
            viewMode === 'grade'
              ? 'bg-primary text-white shadow-lg scale-105'
              : 'bg-white/50 text-gray-600 hover:bg-white/80'
          }`}
        >
          <span className="mr-2">📖</span>
          按年级学习
        </button>
        <button
          onClick={() => setViewMode('category')}
          className={`px-6 py-3 rounded-2xl font-medium transition-all ${
            viewMode === 'category'
              ? 'bg-primary text-white shadow-lg scale-105'
              : 'bg-white/50 text-gray-600 hover:bg-white/80'
          }`}
        >
          <span className="mr-2">📚</span>
          按分类学习
        </button>
      </div>

      {/* Render appropriate view */}
      {viewMode === 'grade' ? (
        <VocabularyGradePage />
      ) : (
        <div className="text-center py-12 bg-white rounded-2xl shadow-soft">
          <div className="text-6xl mb-4">🚧</div>
          <p className="text-gray-500 text-lg">分类学习模式正在开发中...</p>
          <p className="text-gray-400 text-sm mt-2">请暂时使用按年级学习模式</p>
        </div>
      )}
    </div>
  );
}
